var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Action Log"}},[_c('b-card-text',[_vm._v("This is the Action Log page. The feature is under construction.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }